module.exports = __webpack_public_path__ + "img/1F616.c0c422ad.svg";